__turbopack_context__.v({
  "effectBox": "HuOwpq_effectBox",
  "inherit": "HuOwpq_inherit",
  "orbit": "HuOwpq_orbit",
});
